import React  from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const AddressAnnexFormItem = () => {
  return (
    <Item 
      name="address.additional"
      label="Complément"
      wrapperCol={{ span: 15 }}
      labelCol={{ span: 9 }}
    >
      <Input/>
    </Item>
  );
};

export default AddressAnnexFormItem;
